import React, {useEffect, useState} from "react";
import axios from "../../services/axiosInstance";
import maCateImg from "../../assets/img/m-a-cate.png";
import MAdminPageSmallEvent from "./MAdminPageSmallEvent";
import MAdminYmdSmallEvent from "./MAdminYmdSmallEvent";
import MAdminSearchEvent from "./MAdminSearchEvent";
import {MdKeyboardArrowDown, MdOutlineChangeCircle} from "react-icons/md";
import MsgSelectModal from "../../components/web/modal/MsgSelectModal";
import MsgCheckModal from "../../components/web/modal/MsgCheckModal";
import commonCheck from "../../assets/img/commonCheck.png";
import commonClose from "../../assets/img/commonClose.png";
import PickupTrackAddPopup from "../../components/web/modal/PickupTrackAddPopup";

function MAdminPickupPg() {

    const [pickupWaitList, setPickupWaitList] = useState([]);
    const [pickupList, setPickupList] = useState([]);
    const token = localStorage.getItem('adminToken');

    const [tabSt, setTabSt] = useState('픽업대기');

    const handleSelectTabs = ((key) => {
        setTabSt(key);
    })

    const [displayLimitPickupWait, setDisplayLimitPickupWait] = useState(10);
    const [displayLimitPickup, setDisplayLimitPickup] = useState(10);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [pickupList.length, displayLimitPickup, pickupWaitList.length, displayLimitPickupWait]);

    const handleScroll = () => {
        if (window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight) return;
        if (pickupList.length > displayLimitPickup && displayLimitPickup < 30
            || pickupWaitList.length > displayLimitPickupWait && displayLimitPickupWait < 30) {
            setDisplayLimitPickupWait(prevLimit => prevLimit + perPg);
        }
    };

    const [popupVisible, setPopupVisible] = useState(false);

    const togglePopup = () => {
        setPopupVisible(!popupVisible);
    };

    const loadMoreData = () => {
        setDisplayLimitPickup(prevLimit => prevLimit + perPg);
        setDisplayLimitPickupWait(prevLimit => prevLimit + perPg);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [perPg, setperPg] = useState(10);
    const indexOfLast = currentPage * perPg;
    const indexOfFirst = indexOfLast - perPg;
    const handleSelectChange = (eOrValue) => {
        let value;
        if (typeof eOrValue === 'object' && eOrValue.target) {
            value = eOrValue.target.value;
        } else {
            value = eOrValue;
        }
        const newPerPage = parseInt(value);
        setperPg(newPerPage);
        setDisplayLimitPickup(newPerPage);
        setDisplayLimitPickupWait(newPerPage);
        setCurrentPage(1);
    };

    const [searchInput, setSearchInput] = useState('');
    const handleSearchInputChange = (event) => {
        setSearchInput(event.target.value);
    };

    const searchPickupWaitData = pickupWaitList.filter((cData) => (
        (cData?.name || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.address || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.addressDt || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.zipcode || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.trackNum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.telnum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
        (cData?.memberDTO?.userName || '').toLowerCase().includes(searchInput.toLowerCase())
    ));

    const searchPickupData = pickupList.filter((cData) => {
        return (
            (cData?.name || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.address || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.addressDt || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.zipcode || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.trackNum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.telnum || '').toLowerCase().includes(searchInput.toLowerCase()) ||
            (cData?.memberDTO?.userName || '').toLowerCase().includes(searchInput.toLowerCase())
        );
    });


    const selectPickupWaitHistoryList = (() => {
        axios({
            method: 'get',
            url: '/pickup/selectPickupHistoryList',
            params: {
                status: '0'
            },
        })
            .then((response) => {
                console.log("반환값 : ", response.data)
                const sortedData = response.data.sort((a, b) => a.seqNum - b.seqNum);
                setPickupWaitList(sortedData)
            })
            .catch((error) => {
                console.log("조회실패 : ", error)
            })
    })


    // 여기서부터 픽업신청
    const [pickupStartDate, setPickupStartDate] = useState('');
    const [pickupEndDate, setPickupEndDate] = useState('');
    const pickupStartHandle = (e) => {
        setPickupStartDate(e.target.value);
    };
    const pickupEndHandle = (e) => {
        setPickupEndDate(e.target.value);
    };

    useEffect(() => {
        const today = new Date();
        const oneMonthAgo = new Date(today);
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

        const formatDateString = (date) => {
            // return date.toISOString().split('T')[0];
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        setPickupStartDate(formatDateString(oneMonthAgo));
        setPickupEndDate(formatDateString(today));
    }, []);

    const selectPickupHistoryList = (() => {
        const formattedStartDate = pickupStartDate.replace(/-/g, '');
        const formattedEndDate = pickupEndDate.replace(/-/g, '');
        axios({
            method: 'get',
            url: '/pickup/selectPickupHistoryList',
            params: {
                startDate: formattedStartDate,
                endDate: formattedEndDate,
            },
        })
            .then((response) => {
                const sortedData = response.data.sort((a, b) => a.seqNum - b.seqNum);
                setPickupList(sortedData)
            })
            .catch((error) => {
                console.log("조회실패 : ", error)
            })
    })

    // 공통
    useEffect(() => {
        setDisplayLimitPickup(perPg);
        setDisplayLimitPickupWait(perPg);
    }, [perPg]);

    useEffect(() => {
        if (tabSt === "픽업대기") {
            selectPickupWaitHistoryList();
        } else if (tabSt === "픽업신청" && pickupStartDate && pickupEndDate) {
            selectPickupHistoryList();
        }
    }, [tabSt, pickupStartDate, pickupEndDate]);

    const [confirmPickupSt, setConfirmPickupSt] = useState(false);
    const confirmPickupMsg1 = "픽업접수가 완료되었습니까?";
    const confirmPickupMsg2 = "진행 시 접수완료로 처리됩니다";

    const [cancelPickupSt, setCancelPickupSt] = useState(false);
    const cancelPickupMsg1 = "픽업신청을 취소하시겠습니까?";
    const cancelPickupMsg2 = "진행 시 픽업신청이 취소처리 됩니다";

    const [pickupSeqNum, setPickupSeqNum] = useState(null);

    const openConfirmPickupSt = ((seqNum) => {
        setPickupSeqNum(seqNum);
        setConfirmPickupSt(true);
    })
    const closeConfirmPickupSt = (() => {
        setPickupSeqNum(null);
        setConfirmPickupSt(false);
    })

    const openCancelPickupSt = ((seqNum) => {
        setPickupSeqNum(seqNum);
        setCancelPickupSt(true);
    })
    const closeCancelPickupSt = (() => {
        setPickupSeqNum(null);
        setCancelPickupSt(false);
    })

    const modifyPickupStatus = (seqNum) => {
        const targetSeqNum = pickupSeqNum || seqNum;
        axios({
            method: 'post',
            url: '/pickup/modifyPickupStatus',
            params: {
                seqNum: targetSeqNum,
                status: confirmPickupSt ? '1' : cancelPickupSt ? '2' : null
            }
        })
            .then(async (res) => {
                // 각 리스트에 반환된 seqNum 모두 제거
                const data = res.data;
                setPickupWaitList(prev => prev.filter(item => item.seqNum !== data.seqNum));
                setPickupList(prev => prev.map(comment => comment.seqNum === data.seqNum ? data : comment));

                if (confirmPickupSt) {
                    closeConfirmPickupSt();
                } else if (cancelPickupSt) {
                    closeCancelPickupSt();
                }
            })
            .catch((error) => {
                console.log("픽업데이터 상태변경 실패 : ", error)
            });
    };

    const [trackNumAddSt, setTrackNumAddSt] = useState(false);
    const handleChangeValue = (seqNum, currentTrackNum) => {
        setPickupSeqNum(seqNum); // 수정할 seqNum 저장
        setTrackNumAddSt(true);  // 팝업 열기
    };
    const closeTrackNumAddSt = () => {
        setTrackNumAddSt(false);
    }
    const handleSaveTrackNum = (updatedData) => {
        // DB에 저장된 최신 데이터를 받아 해당 seqNum의 데이터만 교체 (실시간 UI 반영)
        setPickupList(prev => prev.map(item =>
            item.seqNum === updatedData.seqNum ? updatedData : item
        ));
        // 필요 시 대기 리스트도 업데이트
        setPickupWaitList(prev => prev.map(item =>
            item.seqNum === updatedData.seqNum ? updatedData : item
        ));
    };






    return (
        <div id="m-a-depositSet-pg-container">
            <div className="m-a-title-frame m-b-5">
                <img className="wd-35 ht-35" alt="" src={maCateImg}/>
                <p className="p-t-6">픽업관리</p>
            </div>
            <div className="m-a-tabs font-t-title font-s-16 p-t-15">
                <div className={`m-a-tab ${tabSt === '픽업대기' ? 'active' : ''}`} onClick={() => handleSelectTabs('픽업대기')}>
                    <p>픽업대기</p>
                </div>
                <div className={`m-a-tab ${tabSt === '픽업신청' ? 'active' : ''}`}
                     onClick={() => handleSelectTabs('픽업신청')}>
                    <p>픽업신청</p>
                </div>
                <div className="m-a-tab-underline"
                     style={{left: `${['픽업대기', '픽업신청'].indexOf(tabSt) * 50}%`}}></div>
            </div>
            <div className="m-a-top-border-card">
                {tabSt === '픽업대기' &&
                    <div>
                        <div className="display-flex flex-column">
                            <div className="m-a-event-frame">
                                <div className="m-a-header-event display-flex flex-row just-cont-sb">
                                    <div className="m-a-header-event-combo">
                                        <div
                                            className="m-a-combo font-t-cont font-c-default wd-55 ht-40 font-s-14 m-a-flex-jc-start m-r-10"
                                            onClick={togglePopup}>
                                            <div className="font-t-cont">{perPg}</div>
                                        </div>
                                        {popupVisible && (
                                            <MAdminPageSmallEvent perPg={perPg} handleSelectChange={handleSelectChange}
                                                                  togglePopup={togglePopup}/>
                                        )}
                                    </div>
                                </div>
                                <div className="m-a-header-event">
                                    <div className="m-a-header-event-search wd-70pc">
                                        <MAdminSearchEvent searchInput={searchInput}
                                                           handleSearchInputChange={handleSearchInputChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="m-a-tb-frame">
                                <div className="m-a-div-tb">
                                    <div className="m-a-div-tb-head ht-60">
                                        <div className="wd-30"><p>번호</p></div>
                                        <div className="wd-150"><p>성함</p></div>
                                        <div className="wd-400"><p>주소</p></div>
                                        <div className="wd-80"><p>상세주소</p></div>
                                        <div className="wd-150"><p>연락처</p></div>
                                        <div className="wd-200"><p>부피 & 무게</p></div>
                                        <div className="wd-150"><p>운송장번호</p></div>
                                        <div className="wd-100"><p>타입</p></div>
                                        <div className="wd-50"><p>상태</p></div>
                                    </div>
                                    {searchPickupWaitData.slice(0, displayLimitPickupWait).map((pw, i) => (
                                        <div key={i} className="m-a-div-tb-body ht-70">
                                            <div className="wd-30"><p>{i + 1}</p></div>
                                            <div className="wd-150"><p
                                                className="font-b">{pw.name} (BT {pw?.memberDTO?.mbNum})</p>
                                            </div>
                                            <div className="wd-400"><p>{pw.address}</p></div>
                                            <div className="wd-80"><p>{pw.addressDt}</p></div>
                                            <div className="wd-150"><p>{pw.telnum}</p></div>
                                            <div className="wd-200"><p>{pw.wid} * {pw.ver} * {pw.hei} - {pw.realWeight}kg</p></div>
                                            <div className="wd-150"><p>{pw.trackNum}</p></div>
                                            <div className="wd-100"><p>{pw.type === '0' ? '해외픽업' : '국내픽업'}</p></div>
                                            <div className="wd-50">
                                                <div className="font-b font-s-13"
                                                     style={{color: pw?.status === '0' ? "#7c9edc" : pw?.status === '1' ? "#48dc50" : '#ff7575'}}>
                                                    {pw?.status === '0' ?
                                                        <div className="user-center">
                                                            <div className="user-center wd-60">
                                                                <img className="c-point wd-30 ht-30 m-a-opc-06"
                                                                     alt="closeImage"
                                                                     src={commonCheck}
                                                                     onClick={() => openConfirmPickupSt(pw.seqNum)}/>
                                                            </div>
                                                            <div className="user-center wd-60">
                                                                <img className="c-point wd-30 ht-30 m-a-opc-07"
                                                                     alt="closeImage"
                                                                     src={commonClose}
                                                                     onClick={() => openCancelPickupSt(pw.seqNum)}/>
                                                            </div>
                                                        </div>
                                                        : pw?.status === '1' ? '완료' : '취소'}
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                            </div>
                            {displayLimitPickupWait >= 30 && searchPickupWaitData.length > displayLimitPickupWait && (
                                <div className="text-center m-t-20">
                                    <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                        <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                }
                {tabSt === '픽업신청' &&
                    <div className="display-flex flex-column">
                        <div className="m-a-event-frame">
                            <div className="m-a-header-event display-flex flex-row just-cont-sb">
                                <div className="m-a-header-event-combo wd-80pc">
                                    <div
                                        className="m-a-combo font-t-cont font-c-default wd-21pc ht-40 font-s-14 m-a-flex-jc-start"
                                        onClick={togglePopup}>
                                        <div className="font-t-cont">{perPg}</div>
                                    </div>
                                    {popupVisible && (
                                        <MAdminPageSmallEvent perPg={perPg} handleSelectChange={handleSelectChange}
                                                              togglePopup={togglePopup}/>
                                    )}
                                    <MAdminYmdSmallEvent startDate={pickupStartDate} endDate={pickupEndDate}
                                                         startHandle={pickupStartHandle}
                                                         endHandle={pickupEndHandle}/>
                                </div>
                                <div className="m-a-header-event-btn font-t-cont font-s-13 wd-20pc">
                                    {/*<button className="m-a-colorBt m-a-colorBt-text wd-100pc ht-40"*/}
                                    {/*        onClick={modifyDepConfirm}>확인*/}
                                    {/*</button>*/}
                                </div>
                            </div>
                            <div className="m-a-header-event">
                                <div className="m-a-header-event-search">
                                    <MAdminSearchEvent searchInput={searchInput}
                                                       handleSearchInputChange={handleSearchInputChange}/>
                                </div>
                            </div>
                        </div>

                        <div className="m-a-tb-frame">
                            <div className="m-a-div-tb m-b-10">
                                <div className="m-a-div-tb-head ht-60">
                                    <div className="wd-30"><p>번호</p></div>
                                    <div className="wd-150"><p>성함</p></div>
                                    <div className="wd-400"><p>주소</p></div>
                                    <div className="wd-80"><p>상세주소</p></div>
                                    <div className="wd-150"><p>연락처</p></div>
                                    <div className="wd-150"><p>부피 & 무게</p></div>
                                    <div className="wd-160"><p>운송장번호</p></div>
                                    <div className="wd-100"><p>타입</p></div>
                                    <div className="wd-50"><p>상태</p></div>
                                </div>
                                {searchPickupData.slice(0, displayLimitPickup).map((p, i) => (
                                    <div key={i} className="m-a-div-tb-body ht-70">
                                        <div className="wd-30"><p>{i + 1}</p></div>
                                        <div className="wd-150"><p
                                            className="font-b">{p.name} (BT {p?.memberDTO?.mbNum})</p>
                                        </div>
                                        <div className="wd-400"><p>{p.address}</p></div>
                                        <div className="wd-80"><p>{p.addressDt}</p></div>
                                        <div className="wd-150"><p>{p.telnum}</p></div>
                                        <div className="wd-150"><p>{p.wid} * {p.ver} * {p.hei} - {p.realWeight}kg</p>
                                        </div>

                                        <div className="user-center flex-row wd-160 ht-100pc gap6">
                                            {p.trackNum && (
                                                <p style={{
                                                    margin: 0,
                                                    lineHeight: "1",
                                                    color: "#7c9edc",
                                                    fontWeight: "bold"
                                                }} className="font-b">
                                                    {p.trackNum}
                                                </p>
                                            )}
                                            <div className="display-flex align-center">
                                                <MdOutlineChangeCircle
                                                    className="c-point btorage-hover btn-click-event m-a-opc-07 font-s-22"
                                                    onClick={() => handleChangeValue(p.seqNum, p.trackNum)}
                                                />
                                            </div>
                                        </div>

                                        <div className="wd-100"><p>{p.type === '0' ? '해외픽업' : '국내픽업'}</p></div>
                                        <div className="wd-50">
                                            <div className="font-b font-s-13"
                                                 style={{color: p?.status === '0' ? "#7c9edc" : p?.status === '1' ? "#48dc50" : '#ff7575'}}>
                                                {p?.status === '0' ?
                                                    <div className="user-center">
                                                        <div className="user-center wd-60">
                                                            <img className="c-point wd-30 ht-30 m-a-opc-06"
                                                                 alt="closeImage"
                                                                 src={commonCheck}
                                                                 onClick={() => openConfirmPickupSt(p.seqNum)}/>
                                                        </div>
                                                        <div className="user-center wd-60">
                                                            <img className="c-point wd-30 ht-30 m-a-opc-07"
                                                                 alt="closeImage"
                                                                 src={commonClose}
                                                                 onClick={() => openCancelPickupSt(p.seqNum)}/>
                                                        </div>
                                                    </div>
                                                    : p?.status === '1' ? '완료' : '취소'}
                                            </div>
                                        </div>

                                    </div>
                                ))}
                            </div>
                            {displayLimitPickup >= 30 && searchPickupData.length > displayLimitPickup && (
                                <div className="text-center m-t-20">
                                    <button className="admin-btn-long admin-btn-basic p-l-10" onClick={loadMoreData}>더보기
                                        <MdKeyboardArrowDown className="m-l3 font-s-17"/>
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                }

            </div>


            {confirmPickupSt ?
                <MsgSelectModal confirmPickupSt={confirmPickupSt} confirmPickupMsg1={confirmPickupMsg1}
                                confirmPickupMsg2={confirmPickupMsg2}
                                closeConfirmPickupSt={closeConfirmPickupSt} pickupSeqNum={pickupSeqNum}
                                modifyPickupStatus={modifyPickupStatus}/>
                :
                cancelPickupSt ?
                    <MsgSelectModal cancelPickupSt={cancelPickupSt} cancelPickupMsg1={cancelPickupMsg1}
                                    cancelPickupMsg2={cancelPickupMsg2}
                                    closeCancelPickupSt={closeCancelPickupSt} pickupSeqNum={pickupSeqNum}
                                    modifyPickupStatus={modifyPickupStatus}/>
                    :
                    trackNumAddSt ?
                        <PickupTrackAddPopup trackNumAddSt={trackNumAddSt} closeTrackNumAddSt={closeTrackNumAddSt}
                                             pickupSeqNum={pickupSeqNum} handleSaveTrackNum={handleSaveTrackNum}/>
                        :
                    null
            }

        </div>

    )

}

export default MAdminPickupPg;